import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SettingField } from "@/components/settings/setting-field";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import type { SaveField } from "../../../hooks/use-auto-save-field";
import { OnlineBookingConfig } from "../hooks/use-online-booking-config";

export function OnlineBookingToggle({
  saveField,
  saving,
}: {
  saveField: SaveField<OnlineBookingConfig>;
  saving: boolean;
}) {
  const { t } = useTranslation("settings");
  const { control } = useFormContext<OnlineBookingConfig>();
  const _enabled = useWatch({
    control,
    name: "enabled",
  });

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="enabled"
        render={({ field }) => (
          <FormItem>
            <SettingField
              label={t("onlineBooking.fields.enable.label")}
              helpText={t("onlineBooking.fields.enable.helpText")}
              helpDetails={
                <div className="space-y-2">
                  <div className="text-sm font-medium text-foreground">
                    {t("onlineBooking.fields.enable.helpDetails.title")}
                  </div>
                  <ul className="text-sm space-y-1 text-muted-foreground">
                    {(
                      t("onlineBooking.fields.enable.helpDetails.benefits", {
                        returnObjects: true,
                      }) as string[]
                    ).map((benefit: string, index: number) => (
                      <li key={index}>• {benefit}</li>
                    ))}
                  </ul>
                </div>
              }
            >
              <FormControl>
                <Switch
                  checked={field.value}
                  disabled={saving}
                  onCheckedChange={(value) => {
                    void saveField("enabled", value);
                  }}
                />
              </FormControl>
            </SettingField>
          </FormItem>
        )}
      />
    </div>
  );
}
